import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div id="footer">
            <div className="container">
                <div className="row">
                    <section className="col-6 col-6-narrower col-12-mobilep">
                        <h3>Sobre</h3>
                        <ul className="links">
                            <li><Link to="/quem-somos">Quem somos</Link></li>
                        </ul>
                    </section>
                    <section className="col-6 col-12-narrower">
                        <h3>Contato</h3>
                        <ul className="links">
                            <li>
                                <a href="https://www.instagram.com/gm_de_coracao/" className="icon brands fa-instagram"><span className="label">Instagram</span></a>
                                &nbsp;&nbsp;&nbsp;
                                <a href="https://wa.me/5541987767716?text=Quero%20um%20produto%20%C3%BAnico" className="icon brands fa-whatsapp"><span className="label">WhatsApp</span></a>
                            </li>
                            <li>Horário de atendimento: Seg-Sex das 08h às 18h</li>
                        </ul>
                    </section>
                </div>
            </div>

            {/* Segurança e Pagamento */}
            <div className="container">
                <div className="row">
                    <section className="col-12" style={{ textAlign: 'center', marginTop: '20px', padding: '20px 0', borderTop: '1px solid #ddd' }}>
                        <h4 style={{ marginBottom: '15px', color: '#666' }}>Segurança e Pagamento</h4>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="fas fa-shield-alt" style={{ color: '#28a745', fontSize: '20px' }}></i>
                                <span style={{ fontSize: '14px', fontWeight: 'bold' }}>Site Seguro SSL</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="fas fa-credit-card" style={{ color: '#007bff', fontSize: '20px' }}></i>
                                <span style={{ fontSize: '14px', fontWeight: 'bold' }}>Pagamento pelo Mercado Pago</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="fas fa-lock" style={{ color: '#6f42c1', fontSize: '20px' }}></i>
                                <span style={{ fontSize: '14px', fontWeight: 'bold' }}>Dados Protegidos</span>
                            </div>
                        </div>
                        <p style={{ marginTop: '10px', fontSize: '12px', color: '#888' }}>
                            Suas informações estão seguras conosco. Utilizamos criptografia SSL e processamento seguro pelo Mercado Pago.
                        </p>
                    </section>
                </div>
            </div>

            {/* Copyright */}
            <div className="copyright">
                <ul className="menu">
                    <li>2022 - {currentYear} &copy; GM de Coração. Direitos reservados</li>
                </ul>
            </div>
        </div>
    );
};

export default Footer;
